import React from "react";
import { Loading } from "../../components";
import { ArrayHelper, ScheduleInterface, ScheduleTimeInterface } from "../../helpers";

interface Props {
  schedules: ScheduleInterface[],
  scheduleTimes: ScheduleTimeInterface[]
}

export const SchedulesOverview: React.FC<Props> = props => {

  const getItems = () => {
    const result: React.ReactElement[] = [];
    for (let i = 0; i < 7; i++) {
      var dayItems = ArrayHelper.getAll(props.scheduleTimes, "dayOfWeek", i)
      ArrayHelper.sort(dayItems, "startMinute", false);
      ArrayHelper.sort(dayItems, "startHour", false);
      dayItems.forEach(st => result.push(getItem(st)));
    }
    return result;
  }

  const getItem = (st: ScheduleTimeInterface) => {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const displayDay = days[st.dayOfWeek];
    const schedule: ScheduleInterface = ArrayHelper.getOne(props.schedules, "id", st.scheduleId);

    return (
      <tr>
        <td>{displayDay}</td>
        <td>{getDisplayTime(st.startHour, st.startMinute)}</td>
        <td>{getDisplayTime(st.endHour, st.endMinute)}</td>
        <td>{schedule?.name}</td>
      </tr>

    );
  }

  const getDisplayTime = (hour: number, min: number) => {
    var amPm = "am";
    if (hour >= 12) {
      hour = hour - 12;
      amPm = "pm";
    }
    if (hour === 0) hour = 12
    const displayHour = String(hour).padStart(2, "0");
    const displayMin = String(min).padStart(2, "0");
    return displayHour + ":" + displayMin + amPm;
  }

  if (!props.schedules || !props.scheduleTimes) return <Loading />
  else return (
    <>
      <div><b>Overview</b></div>
      <table className="table table-sm" style={{ fontSize: 13 }} >
        <thead><tr><th>Day</th><th>Start</th><th>End</th><th>Schedule</th></tr></thead>
        <tbody>{getItems()}</tbody>
      </table>
    </>
  );
};